import { AbstractControl, FormGroup } from '@angular/forms';
import { HostListener, Injectable, inject } from '@angular/core';
import { ComponentCanDeactivate } from '@app/shared/guards/unsaved-changes.guard';
import { ConfirmationModalService } from '@app/partials/modal/confirmation-modal.service';

@Injectable()
export abstract class AbstractEntityEditComponent implements ComponentCanDeactivate {
  protected readonly confirmationModal = inject(ConfirmationModalService);
  // hasFormError = false;
  // saving = false;
  //
  // labels: { key: string; value: string }[] = [];
  //
  // getLabel(key: string) {
  //   return this.labels.find((l) => l.key === key)?.value || key;
  // }

  static bindErrorsToForm(responseErrors: any, form: FormGroup) {
    if (!responseErrors || !responseErrors.errors) {
      return;
    }
    for (const field of Object.keys(responseErrors.errors)) {
      AbstractEntityEditComponent.bindErrorsToControl(responseErrors.errors[field], form.controls[field]);
    }
  }

  static bindErrorsToControl(responseErrors: any, control: AbstractControl | null) {
    if (control) {
      let errors = control.errors || {};
      for (const error of responseErrors) {
        errors[error] = error;
      }
      control.setErrors(errors);
      control.markAsDirty();
      control.markAsTouched();
    }
  }

  getFormValidationErrors(form: FormGroup): string[] {
    const errors: string[] = [];
    Object.keys(form.controls).forEach((key) => {
      const controlErrors = form.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          errors.push(`${key} has error: ${errorKey}`);
        });
      }
    });
    return errors;
  }

  // static formatErrorsMessage(responseErrors: any): string {
  //   let str = '';
  //   for (const field of Object.keys(responseErrors)) {
  //     for (const error of responseErrors[field]) {
  //       str += field + ': ' + error.message;
  //     }
  //   }
  //   return str;
  // }

  // CanDeactivate guard implementation
  async canDeactivate(): Promise<boolean> {
    const forms = this.getForms();
    const hasDirtyForms = forms.some(form => form && form.dirty);
    
    if (!hasDirtyForms) {
      return true;
    }

    return this.confirmationModal.confirm({
      title: 'Unsaved changes',
      message: 'You have unsaved changes. Are you sure you want to leave this page?',
      confirmLabel: 'Leave Page',
      cancelLabel: 'Stay Here',
      confirmButtonStyle: 'danger',
    });
  }

  // Handle browser refresh/close
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    const forms = this.getForms();
    const hasDirtyForms = forms.some(form => form && form.dirty);
    
    if (hasDirtyForms) {
      $event.returnValue = true;
    }
  }

  // Abstract method that components should implement to return their forms
  protected abstract getForms(): FormGroup<any>[];
}
